/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2024-01-02 15:28:34
 * @LastEditors: caiqin.xie
 * @message: 售后服务政策
 * @url: www.picoxr.com/cn/after-service
 */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Select } from "@arco-design/web-react";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import WarrantyTable from './components/WarrantyTable'
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'
import classNames from "classnames";
const Option = Select.Option;

interface IPeriod {
  name: string;
  paramBOs: Record<string, string>[]
}

const AfterService = (props: any) => {
  const {ctry, words, data} = props.data
  const [currentId, setCurrentId] = useState<string>(data?.id || '') // 当前产品id
  const [warrantyTitle, setWarrantyTitle] = useState<string>(data?.warrantyPolicyTitle || '') // 保修政策标题
  const [warrantyPolicy, setWarrantyPolicy] = useState<string>(data?.warrantyPolicy || '') // 保修政策内容
  const [warrantyPeriods, setWarrantyPeriods] = useState<IPeriod[]>(data?.warrantyPeriods || []) // 保修周期
  const productList: Record<string, string>[] = data?.bProducts || [] // 产品列表

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/after-service`} />
      ))
    )
  }

  // 渲染政策
  const creatHtml = () => {
    return {__html: warrantyPolicy}
  }
  // 产品切换获取对应政策
  const getPolicyData = (id: string) => {
    request.post(`${DOMAIN_API}/o/product/getMaintenance`, {
      id,
      stationCode: ctry
    })
    .then(res => {
      const {warrantyPolicyTitle, warrantyPolicy, warrantyPeriods} = res.data
      setWarrantyTitle(warrantyPolicyTitle)
      setWarrantyPolicy(warrantyPolicy)
      setWarrantyPeriods(warrantyPeriods)
    })
    .catch(err => {
      console.log(err)
    })
  }
  // 切换产品
  const handleChange = (value: string) => {
    setCurrentId(value)
    getPolicyData(value)
  }

  return (
    <div>
      <Helmet>
        <title>{words?.support_policy_seo_title}</title>
        <meta name="description" content={words?.support_policy_seo_description} />
        <meta name="keywords" content={words?.support_policy_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/after-service`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['after-sales-wrap']}>
        <div className={styles['after-sales-content-wrap']}>
          <h1 className={styles['after-sales-title']}>
            {words?.support_warranty_policy_title}
          </h1>
          <div className={styles['after-sales-select-wrap']}>
            <Select
              size="large"
              className={styles['after-sales-select']}
              placeholder={words?.support_warranty_policy_select}
              onChange={(value) => handleChange(value)}
              value={currentId}>
                {productList.map(item => (
                  <Option key={item.id} value={item.id}>{item.name}</Option>
                ))}
            </Select>
          </div>
          <section className={styles["after-sales-section"]}>
            {/* 2023-11-14 需求改动：不显示标题，标题在富文本中体现 */}
            {/* <h2>{warrantyTitle}</h2> */}
            <div className={classNames(styles["after-sales-item"], 'editor-wrap')} dangerouslySetInnerHTML={creatHtml()}></div>
          </section>
          {/* 2023-11-13 去掉该功能 */}
          {/* <WarrantyTable ctry={ctry} words={words} list={warrantyPeriods} /> */}
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/product/getMaintenance`, {
      stationCode: ctry
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

AfterService.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default AfterService;
